/**
 * ListCard - Mobile
 * 
 * Flat card with subtle border.
 * No shadows - borders provide structure per theme.
 */

import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { color, radius, border } from '../../../shared/tokens/mobile';

interface ListCardProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export function ListCard({ children, style }: ListCardProps) {
  return (
    <View style={[styles.card, style]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: color.surface,
    borderRadius: radius.md,
    borderWidth: border.width.thin,
    borderColor: color.border,
    overflow: 'hidden',
  },
});
